/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormView } from './form-view.model';
import { Note } from './note.model';
import { Company } from './company.model';
import { IClient } from '../constants';

export class Submission {
  constructor(
    public id?: string | number,
    public metadata?: CustomerFormMetadata | Record<string, any>,
    public responses?: any,
    public status?: string,
    public note?: Note,
    public company?: Company,
    public form?: FormView,
    public client?: IClient,
    public createdAt?: string,
    public updatedAt?: string
  ) {
  }
}

export interface CustomerFormMetadata {
  clientId?: string | number;
  agentId?: string | number;
  companyId?: string | number;
  submissionId?: string | number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  formId?: string;
  version?: number;
  referredBy?: string;
  unitNumber?: string | number;
}

export interface FileUploadResponse {
  clientId: number;
  createdAt: string;
  fileName: string;
  id: number;
  objName: string;
  updatedAt: string;
  uuid: string;
  data: { objName: string, originalFileName: string };
}

export interface IDataPullType {
  type: 'OCR' | 'DATA',
  loadSeconds: number
}
